import { Component, Inject, OnInit } from '@angular/core';
import { environment } from '@environments/environment';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { PopupComponent } from '@components/popup/popup.component';
import { TranslateService } from '@ngx-translate/core';
import { GlobalTranslationService } from '@services/global-translation.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit{
  title = 'Intercessory';
  firstName: string;

  constructor(private dialogRef : MatDialog, private globalTranslationService: GlobalTranslationService) {
    // Set available languages from environment
    //translate.addLangs(environment.supportedLanguages);
    
    // Set default language from environment
    //translate.setDefaultLang(environment.defaultLanguage);
    
    // Detect browser language or use default
    //const browserLang = translate.getBrowserLang();
    //translate.use(browserLang?.match(/en|es/) ? browserLang : environment.defaultLanguage);
  }

openDialog() {
  this.dialogRef.open(PopupComponent, {
    data : {
      name : 'Samuel'
  }
});
}


  getUrl() {
    return "url('assets/sky8.jpg')";
  }

  ngOnInit() {
    // debugger; // Add this line for testing
    console.log('App component initialized'); // Add breakpoint here
    
    if (environment.production) {
      if (location.protocol === 'http:') {
        window.location.href = location.href.replace('http', 'https');
      }
    }

    // Optional: Add any additional initialization logic here
    console.log('Current language:', this.globalTranslationService.getCurrentLanguage());
    console.log('Supported languages:', this.globalTranslationService.getSupportedLanguages());
  }
}
